import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ReservationProvider } from "./components/ReservationModal";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import StickyMobileCTA from "./components/StickyMobileCTA";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import Restaurant from "./pages/Restaurant";
import Safranbolu from "./pages/Safranbolu";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/legal/Privacy";
import CookiePolicy from "./pages/legal/CookiePolicy";
import Kvkk from "./pages/legal/Kvkk";
import Terms from "./pages/legal/Terms";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ReservationProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/odalar" element={<Rooms />} />
              <Route path="/restoran" element={<Restaurant />} />
              <Route path="/safranbolu" element={<Safranbolu />} />
              <Route path="/galeri" element={<Gallery />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/gizlilik-politikasi" element={<Privacy />} />
              <Route path="/cerez-politikasi" element={<CookiePolicy />} />
              <Route path="/kvkk" element={<Kvkk />} />
              <Route path="/kullanim-kosullari" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <StickyMobileCTA />
          <CookieConsent />
          {/* Mobile spacer so sticky CTA doesn't cover footer content */}
          <div className="h-14 md:hidden" />
          <Toaster position="top-center" richColors />
        </ReservationProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
